<div
	class="form-control text-control"
	[formGroup]="form"
	[ngClass]="{ 'not-labelled': label === null }"
	[class.invalid]="isInvalid()"
	[class.valid]="isValid()"
	[class.required]="isRequired()"
	[class.has-validation-icon]="show_validation_icon"
>
	<label *ngIf="label" for="input" [for]="form_control_id" class="label">{{ label }}{{ getRequired() }} {{ getError() }}</label>
	<label *ngIf="!label && render_label_placeholder" class="label">&nbsp;</label>

	<div class="control-container" [class.in-focus]="is_focused">
		<label *ngIf="!!prefix" [for]="form_control_id" class="prefix">{{ prefix }}</label>

		<div>
			<input
				*ngIf="!isSpecialInput"
				id="input"
				[id]="form_control_id"
				[attr.name]="form_control_name"
				[type]="input_type"
				[formControlName]="form_control_name"
				[ngClass]="input_css_classes"
				[attr.spellcheck]="spellcheck"
				[attr.placeholder]="placeholder"
				[attr.maxlength]="max_length"
				[attr.autocomplete]="autocomplete === false ? 'new-password' : null"
				[attr.min]="min_date"
				[attr.max]="max_date"
				(focus)="onFocus()"
				(blur)="onBlur()"
				(input)="onInput()"
			/>

			<input
				*ngIf="input_type === 'number'"
				id="input"
				[id]="form_control_id"
				[attr.name]="form_control_name"
				[type]="input_type"
				[formControlName]="form_control_name"
				[ngClass]="fakePasswordClasses"
				[attr.placeholder]="placeholder"
				[attr.maxlength]="max_length"
				[attr.autocomplete]="autocomplete === false ? 'new-password' : null"
				(focus)="onFocus()"
				(blur)="onBlur()"
				(input)="onInput()"
				pattern="[0-9.]*"
				inputmode="numeric"
			/>

			<textarea
				*ngIf="input_type === 'textarea' && autosize"
				id="textarea_autosize"
				[id]="form_control_id"
				[attr.name]="form_control_name"
				[formControlName]="form_control_name"
				[ngClass]="input_css_classes"
				[attr.spellcheck]="spellcheck"
				[attr.placeholder]="placeholder"
				[attr.maxlength]="max_length"
				[attr.autocomplete]="autocomplete === false ? 'new-password' : null"
				(focus)="onFocus()"
				(blur)="onBlur()"
				(input)="onInput()"
				rows="1"
				autosize
			></textarea>

			<textarea
				*ngIf="input_type === 'textarea' && !autosize"
				id="textarea_fixed"
				[id]="form_control_id"
				[attr.name]="form_control_name"
				[formControlName]="form_control_name"
				[ngClass]="input_css_classes"
				[attr.spellcheck]="spellcheck"
				[attr.placeholder]="placeholder"
				[attr.maxlength]="max_length"
				(focus)="onFocus()"
				(blur)="onBlur()"
				(input)="onInput()"
				rows="6"
			></textarea>
		</div>
		<label *ngIf="!!suffix" [for]="form_control_id" class="suffix">{{ suffix }}</label>
		<div class="validation-icon">
			<i class="fas fa-check"></i>
			<i class="fas fa-xmark"></i>
		</div>
	</div>

	<span *ngIf="info !== null" class="info" [class.highlighted]="highlighted_info">
		{{ info }}
	</span>
</div>
